import { Link } from '@online-webinar/ui-frontend';
import { Popup } from '../../atoms';

export const WebinarErrorPopup = ({ webinarId, title, message }: { webinarId: string; title: string; message: string }) => {
    return (
        <Popup isCloseFunctionality={false} hasWarning={true} onClose={() => {}} onConfirm={() => {}} open={true} title={title}>
            <div>
                <p className="notallowed-broadcast">{message}</p>
                <Link to="/$webinarId/content" params={{ webinarId }} variant="primary-outline" classNames="mt-4">
                    Go back
                </Link>
            </div>
        </Popup>
    );
};
